export const getContextsData = state => state.contextSetting.contexts.data;
export const getContextsIsLoading = state => state.contextSetting.contexts.get.loading;